import { Flex } from 'antd';
import { CircleFlag } from 'react-circle-flags';
import PropTypes from 'prop-types';

export const PhoneCodeOption = ({ country }) => {
    return (
        <Flex align='center' gap={10}>
            <CircleFlag countryCode={country?.code.toLowerCase()} height="18" />
            <div>{country?.name}</div>
            <div>{country?.phone_code}</div>
        </Flex>
    );
};

PhoneCodeOption.propTypes = {
  country: PropTypes.shape({
    code: PropTypes.string.isRequired,
    name: PropTypes.string,
    phone_code: PropTypes.string
  })
};
